import { Star } from "lucide-react";
import SidebarItemRow from "./SidebarItemRow";

/**
 * Pinned favourites block at the top of the sidebar. Rendered only when the
 * user has 1+ items pinned. Each row is a normal `SidebarItemRow` in "pinned"
 * mode — clicking the pin icon there unpins.
 */
export default function SidebarPinnedSection({
  items,          // resolved pinned items (icon/label/colour + `.to`)
  collapsed,
  onTogglePin,    // (to) => void
  onContextMenu,  // (event, to) => void
}) {
  if (!items || items.length === 0) return null;
  return (
    <div className="mb-2" data-testid="sidebar-pinned-section">
      {!collapsed && (
        <div className="px-4 pb-1 text-[10px] uppercase tracking-widest text-slate-500 flex items-center gap-1.5">
          <Star className="w-3 h-3 text-orange-400 fill-orange-400/40" />
          Pinned
        </div>
      )}
      <div className="px-2 space-y-0.5">
        {items.map((it) => (
          <SidebarItemRow
            key={`pin-${it.to}`}
            item={it}
            collapsed={collapsed}
            isPinnedItem
            showStar={false}
            onTogglePin={() => onTogglePin(it.to)}
            onContextMenu={(e) => onContextMenu(e, it.to)}
            testIdPrefix="sidebar-pinned"
          />
        ))}
      </div>
      <div className="mx-3 my-2 border-t border-white/[0.06]" />
    </div>
  );
}
